import { Component } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { DataService } from '../../services/data.service';
import { LocalizationService } from '../../services/localization.service';

@Component({
    selector: 'app-pg-supplier-delete-confirm',
    templateUrl: './pg-supplier-delete-confirm.component.html',
    standalone: false
})
export class PgSupplierDeleteConfirmComponent {

    experienceLabels:Array<string> = [];
    totalCount = 0;

    constructor(public modal: NgbActiveModal) {}

    static formatExperienceLabels(items: Array<any>, total: number, localizationService: LocalizationService): Array<string> {
        let _labels = (items || []).map((item) => {
            let _id = item?.id != null ? String(item.id) : '';
            let _title = localizationService.getTranslatedValue(item?.title, true);
            if(_title == null || _title === '') {
                return _id;
            }
            return _id !== '' ? (_id + ' - ' + _title) : _title;
        }).filter((label) => label !== '');

        if(total > _labels.length) {
            _labels = _labels.concat(['...']);
        }
        return _labels;
    }

    /**
     * For supplier resources with associated experiences, opens a confirmation modal listing up to 5 experiences.
     * Resolves true when delete can proceed (not a supplier, no experiences, or user confirmed).
     */
    static confirmIfNeeded(modalService: NgbModal, dataService: DataService, localizationService: LocalizationService, resourceId: string, elementId: string): Observable<boolean> {
        return new Observable<boolean>((observer) => {
            if (!dataService.isSupplierResource(resourceId)) {
                observer.next(true);
                observer.unsubscribe();
                return;
            }

            dataService.getSupplierAssociatedExperiences(resourceId, elementId, 5).subscribe((result) => {
                if (result == null || result.total < 1) {
                    observer.next(true);
                    observer.unsubscribe();
                    return;
                }

                let _modalRef = modalService.open(PgSupplierDeleteConfirmComponent);
                let _instance = _modalRef.componentInstance as PgSupplierDeleteConfirmComponent;

                _instance.totalCount = result.total;
                _instance.experienceLabels = PgSupplierDeleteConfirmComponent.formatExperienceLabels(result.items, result.total, localizationService);

                _modalRef.result.then(() => {
                    observer.next(true);
                    observer.unsubscribe();
                }, () => {
                    observer.next(false);
                    observer.unsubscribe();
                });
            });
        });
    }
}
